export const areAllFieldsFilled = (values) => {
  return Object.values(values).every(
    (field) =>
      Array.isArray(field) &&
      field.every(
        (value) => value !== '' && value !== null && value !== undefined
      )
  )
}
